import { render, staticRenderFns } from "./fullScreenIndex.vue?vue&type=template&id=ecc52088"
import script from "./fullScreenIndex.vue?vue&type=script&lang=js"
export * from "./fullScreenIndex.vue?vue&type=script&lang=js"
import style0 from "./fullScreenIndex.vue?vue&type=style&index=0&id=ecc52088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports